<template>
  <div class="sc-message--text" 
      :class="{
        sent: message.author === 'me',
        received: message.author !== 'me'
      }">
      <!-- :style="messageColors" -->
    <p v-html="data"></p>
    
    <!-- <p v-if="data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{data.meta}}</p> -->
  </div>
</template>

<script>
// import escapeGoat from 'escape-goat'
// import Autolinker from 'autolinker'
// const fmt = require('msgdown')

export default {
  data() {
    return {
      messageShow: ''
    };
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    // data: {
    //   type: Object,
    //   required: true
    // },
    // messageColors: {
    //   type: Object,
    //   required: true
    // },
    // messageStyling: {
    //   type: Boolean,
    //   required: true
    // }
  },
  computed: {
    data() {
      var contentData = {}
      contentData = JSON.parse(JSON.stringify(this.message))
      // 處理 超連結 和 email
      // this.$set(contentData.data, 'text', this.$handleMessageText(contentData.data.text))
      // console.log('處理後 : ' + this.message.data.text)
      // console.log('處理後 : ' + contentData.data.text)
      // return contentData.data.text
      return JSON.parse(this.message.msgJson).html
    }
  },
  methods: {
  }
}
</script>

<style scoped>
@import "./styles/textMessage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/HtmlMessage.vue